module.exports = __webpack_public_path__ + "static/media/pinned_collar.e267b206.svg";